import { Component, Inject } from '@angular/core';
import { NgbDate, NgbDateStruct } from '@cmps/ng-bootstrap';
import { CmpsPeriodCompareData, CmpsPeriodCompareType } from '@cmps/ng-kit';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';

import { CacheDate } from '../models/cache-model';
import { PeriodCompareDialogData } from '../models/period-compare-dialog.model';
import { TranslationKeyMap } from '../my-performance-card.i18n';

import { PeriodCompareDialogResult } from './period-compare-dialog-result.model';
import { SelectedPeriodData } from './period-compare-selection-model';
@Component({
    selector: 'cmps-period-compare-dialog',
    templateUrl: './period-compare-dialog.component.html',
})
export class CmpsPeriodCompareDialogComponent {
    /** @private */ _cmpsWeekData: CmpsPeriodCompareData[];
    /** @private */ _cmpsMonthData: CmpsPeriodCompareData[];
    /** @private */ _today: Date;
    /** @private */ _model: NgbDateStruct;

    /** @private */ _i18n = TranslationKeyMap;

    isDisabled;

    constructor(
        /** @private */ public readonly _dialogRef: CmpsDialogRef<
            CmpsPeriodCompareDialogComponent,
            PeriodCompareDialogResult
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _dialogData: PeriodCompareDialogData,
    ) {
        if (_dialogData.data != null || _dialogData.data.length === 0) {
            this.isDisabled = () => true;
            return;
        }
        this._cmpsWeekData = [];
        this._cmpsMonthData = [];
        this._today = new Date();
        const daysPeriod = _dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.DAYS,
        );
        this.isDisabled = (date: NgbDateStruct) => {
            return (
                daysPeriod?.cacheDates != null &&
                daysPeriod.cacheDates.find(
                    (x) =>
                        x.date != null &&
                        new NgbDate(
                            x.date.year,
                            x.date.month,
                            x.date.day,
                        ).equals(date) &&
                        x.options !== _dialogData.selectedPeriodOption,
                ) == null
            );
        };
        const weekPeriod = _dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.WEEKS,
        );
        weekPeriod?.cacheDates.forEach((e) =>
            this._cmpsWeekData.push({
                option: e.options,
                disabled: _dialogData.selectedPeriodOption === e.options,
            }),
        );
        const monthPeriod = _dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.MONTHS,
        );
        monthPeriod?.cacheDates.forEach((e) =>
            this._cmpsMonthData.push({
                option: e.options,
                disabled: _dialogData.selectedPeriodOption === e.options,
            }),
        );
    }

    /** @private */
    _onSelectAction(selectedValue: SelectedPeriodData): void {
        let date: Date;
        let value: CacheDate;
        const dayPeriod = this._dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.DAYS,
        );
        const weekPeriod = this._dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.WEEKS,
        );
        const monthPeriod = this._dialogData.data.find(
            (e) => e.periodType === CmpsPeriodCompareType.MONTHS,
        );
        switch (selectedValue.periodType) {
            case CmpsPeriodCompareType.DAYS:
                if (this._model != null) {
                    date = new Date(
                        this._model.year,
                        this._model.month - 1,
                        this._model.day,
                    );
                }
                value = dayPeriod?.cacheDates.find(
                    (e) => new Date(e.endDate).getTime() === date.getTime(),
                );
                break;
            case CmpsPeriodCompareType.WEEKS:
                value = weekPeriod?.cacheDates.find(
                    (e) => e.options === selectedValue.val,
                );
                break;
            case CmpsPeriodCompareType.MONTHS:
                value = monthPeriod?.cacheDates.find(
                    (e) => e.options === selectedValue.val,
                );
        }
        this._dialogRef.close({ selected: value });
    }
}
